import styled from 'styled-components';

import { font } from 'shared/utils/styles';

const Content = styled.div`
  padding: 0 !important;
  ${font.size(15)}
  ${font.regular}
`;

export default Content;
